import React, { lazy, Suspense, useEffect } from 'react';
import { Spin } from 'antd';
import { Route, Router, Switch, useLocation } from 'react-router-dom';
import useHistory from './hooks/useHistory';
import HeadContent from './components/HeadContent/HeadContent';
import LoanIndex from './loan/routes';
import LogoutStep from './loan/components/LogoutStep';
import MyApps from './loan/components/MyApps';
import { observer } from 'mobx-react-lite';
import PartnerLoan from './loan/components/PartnerLoan/PartnerLoan';
import PreQualFunnelIndex from './prequal';
import LendAPICombinedLogout from './prequal/components/LendAPICombinedLogout';
import LendAPICombinedMyApps from './prequal/components/LendAPICombinedMyApps';
import LendAPICombinedSuccess from './prequal/components/LendAPICombinedSuccess';
import { isFromLendAPICombinedFunnel } from './utils/logoutRedirectHelper';

import { gotoStep, Route as StepRoute } from './nav';

function LogoutRouter() {
  const location = useLocation();
  return isFromLendAPICombinedFunnel(location.search) ? <LendAPICombinedLogout /> : <LogoutStep />;
}

function MyAppsRouter() {
  const location = useLocation();
  return isFromLendAPICombinedFunnel(location.search) ? <LendAPICombinedMyApps /> : <MyApps />;
}

type Props = {
  basePath?: string;
  transitionsLoaded?: boolean;
  loan?: any;
};

const Admin = lazy(() => import(/* webpackChunkName: "admin" */ './admin/index'));

export default observer(function Routes({
  basePath = '/apply',
  transitionsLoaded = false,
  loan,
}: Props) {
  const history = useHistory(basePath);

  if (!window.location.pathname.includes(basePath)) {
    // Using history will prefix the pathname with the basePath
    history.push(`${window.location.pathname}${window.location.search}`);
  }

  useEffect(() => {
    const w: any = window;
    w.TF = w.TF || {};
    // add some navigation utilities for test
    w.TF.gotoStep = (step: StepRoute) => gotoStep(history, step);
    w.TF.history = history;
  }, [history]);

  return (
    <Router history={history}>
      <HeadContent loan={loan} />
      <Switch>
        <Route path="/admin">
          <Suspense fallback={<Spin />}>
            <Admin />
          </Suspense>
        </Route>
        <Route path="/logout">
          <LogoutRouter />
        </Route>
        <Route path="/profile/success/:loanId">
          <LendAPICombinedSuccess />
        </Route>
        <Route path="/profile/apps">
          <MyAppsRouter />
        </Route>
        <Route path="/partner-loan/:partnerLoanId">
          <PartnerLoan />
        </Route>
        <Route path="/pre-qualify/*" exact>
          <PreQualFunnelIndex />
        </Route>
        <Route path="/">
          <LoanIndex transitionsLoaded={transitionsLoaded} />
        </Route>
      </Switch>
    </Router>
  );
});
